<template>
	<div v-if="show" :class="slideInClass">
		<nav v-if="matrix">
			<template
				v-for="category in matrix.categories"
			>
				<h4>{{ category.label }}</h4>
				<ul>
					<li
						v-for="row in category.rows"
						:key="row.id"
						:class="[
							'more-left-padding',
							{'active': selectedRow && selectedRow.id === row.id},
							{'disabled': !hasValues(row)},
							{'completed': hasFilteredValues(row)}
						]"
					>
						<a :href="hasValues(row) ? '#' : ''" @click.prevent="selectRow(row)">
							<Icon v-if="hasFilteredValues(row)" icon="checkmark"/>
							<span class="label">
								{{ row.label }}
								<span v-if="hasFilteredValues(row)">({{ getFilteredValuesAmount(row)}})</span>
							</span>
							<span v-if="!hasValues(row)" class="sublabel">Derzeit keine</span>
						</a>
					</li>
				</ul>
			</template>
		</nav>
		<div class="edit-area">
			<header class="titled">
				<div>
					<h1>{{ selectedRow ? selectedRow.label : ''}}</h1>
				</div>
				<div class="close-container">
					<a href="#" @click.prevent="closeFan(false)">
						<Icon icon="close"/>
					</a>
				</div>
			</header>
			<main class="scrollbar-check">
				<Loading v-if="loading" />
				<template v-else>
					<div v-if="!selectedRow">Wähle links aus was du genauer filtern möchtest.</div>
					<div v-else>
						<Row :row="selectedRow"/>
					</div>
				</template>
			</main>
			<footer v-if="!loading">
				<Button
					text="Ergebnisse anzeigen"
					icon="checkmark"
					@click="closeFan(true)"
				/>
			</footer>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Icon from "@/vue/icon/Icon"
import FuzzyMatrix from "@/api/job/FuzzyMatrix";
import Loading from "@/vue/common/Loading";
import Button from "@/vue/common/Button";
import Row from "@/vue/application/job/fuzzy-matrix/Row";
import {getClasses} from "@/helper/layout/Fan";
import {OPEN_FAN_KEY} from "@/store/job/fuzzy-matrix";

export default {

	components: {
		Button,
		Loading,
		Icon,
		Row,
	},

	data ()
	{
		return {
			loading: true,
			matrix: undefined,
			selectedRow: undefined,
		};
	},

	computed: {
		...mapState('job/fuzzyMatrix', [
			'show',
			'job',
			'filterValues'
		]),
		...mapState('layout', ['fanLevelClasses']),
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['job-fuzzy-matrix']
			});
		}
	},

	methods: {
		...mapActions('job/fuzzyMatrix', [
			'close'
		]),
		hasValues (row)
		{
			return row.values.length > 0;
		},
		selectRow (row)
		{
			if (!this.hasValues(row))
			{
				return;
			}

			this.selectedRow = row;
		},
		closeFan (confirm)
		{
			this.close({
				confirm
			});
		},
		async loadFuzzyMatrix ()
		{
			this.loading = true;

			const response = await new FuzzyMatrix()
				.setJob(this.job.id)
				.call();

			this.matrix = response.data.matrix;

			this.loading = false;
		},
		hasFilteredValues (row)
		{
			return this.getFilteredValuesAmount(row) > 0;
		},
		getFilteredValuesAmount (row)
		{
			if (!this.filterValues)
			{
				return 0;
			}

			const valueIds = _.map(row.values, 'id');
			const filterValueIds = _.map(this.filterValues, 'id');

			return _.intersection(valueIds, filterValueIds).length
		}
	},

	watch: {
		job (job)
		{
			if (job)
			{
				this.loadFuzzyMatrix();
			}
		},
	}
}
</script>
